// extracted by mini-css-extract-plugin
export default {"button":"StoreButton_button_rLRuC","icon":"StoreButton_icon_GpNTz"};